import React from 'react';

const DrivenIconSVG = ({ width, height }) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox="0 0 64 64" style={{ fill: 'rgba(0, 0, 0, 1)', enableBackground: 'new 0 0 64 64' }}>
        <style>
            {`.st0{fill:#2C3177;}
              .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
              .st2{fill:#FFFFFF;}
              .st3{fill:none;stroke:#FFFFFF;stroke-width:1.4893;stroke-miterlimit:10;}
              .st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2238;stroke-miterlimit:10;}`}
        </style>
        <path
            className="st0"
            d="M58.05,63.99H5.97c-3.24,0-5.89-2.65-5.89-5.89V5.92c0-3.24,2.65-5.89,5.89-5.89h52.07
            c3.24,0,5.89,2.65,5.89,5.89V58.1C63.93,61.34,61.28,63.99,58.05,63.99z"
        />
        <g>
            <path
                className="st4"
                d="M15.48,26.89l2.89-7.82c1.06-2.04,2.68-3.31,4.58-3.95h18.11c1.9,0.63,3.45,1.9,4.58,3.95l2.89,7.82h3.73
                c0.28,0,0.49,0.21,0.49,0.49v1.55c0,0.28-0.21,0.56-0.49,0.56h-2.18c0.63,0.78,1.27,1.69,1.9,2.89c0,4.72,0.07,9.44,0.07,14.23
                c0,1.2-0.99,2.25-2.25,2.25h-1.55c-1.27,0-2.25-1.06-2.25-2.25v-2.89H18.01v2.89c0,1.2-0.99,2.25-2.25,2.25h-1.55
                c-1.27,0-2.25-1.06-2.25-2.25c0-4.79,0.07-9.51,0.07-14.23c0.63-1.2,1.27-2.11,1.9-2.89h-2.18c-0.28,0-0.49-0.28-0.49-0.56v-1.55
                c0-0.28,0.21-0.49,0.49-0.49H15.48z M23.3,18.23c-1.2,0.21-1.97,0.99-2.4,1.97c-0.85,2.33-1.76,5-2.54,7.33h27.27
                c-0.78-2.33-1.76-5-2.54-7.33c-0.49-0.99-1.2-1.76-2.4-1.97H23.3z M44.86,32.6c-1.41,0-2.54,1.13-2.54,2.54s1.13,2.54,2.54,2.54
                c1.34,0,2.47-1.13,2.47-2.54S46.2,32.6,44.86,32.6z M19.14,32.6c1.41,0,2.54,1.13,2.54,2.54s-1.13,2.54-2.54,2.54
                c-1.34,0-2.47-1.13-2.47-2.54S17.8,32.6,19.14,32.6z"
            />
        </g>
    </svg>
);

export default DrivenIconSVG;
